var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingcart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04163 1.54167H5.20829L7.99996 15.4896C8.09521 15.9692 8.35611 16.4 8.73698 16.7066C9.11786 17.0132 9.59444 17.176 10.0833 17.1667H20.2083C20.6971 17.176 21.1737 17.0132 21.5546 16.7066C21.9355 16.4 22.1964 15.9692 22.2916 15.4896L23.9583 6.75001H6.24996M10.4166 22.375C10.4166 22.9503 9.95026 23.4167 9.37496 23.4167C8.79966 23.4167 8.33329 22.9503 8.33329 22.375C8.33329 21.7997 8.79966 21.3333 9.37496 21.3333C9.95026 21.3333 10.4166 21.7997 10.4166 22.375ZM21.875 22.375C21.875 22.9503 21.4086 23.4167 20.8333 23.4167C20.258 23.4167 19.7916 22.9503 19.7916 22.375C19.7916 21.7997 20.258 21.3333 20.8333 21.3333C21.4086 21.3333 21.875 21.7997 21.875 22.375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/Shopping cart.41de0d75a9b9f0c4e7d5cbe76c6dc829.svg";
export { ForwardRef as ReactComponent };